import { render, staticRenderFns } from "./P0906.vue?vue&type=template&id=266f3319&scoped=true&"
import script from "./P0906.vue?vue&type=script&lang=ts&"
export * from "./P0906.vue?vue&type=script&lang=ts&"
import style0 from "./P0906.vue?vue&type=style&index=0&id=266f3319&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266f3319",
  null
  
)

export default component.exports